<template>
  <div class="captcha_field">
    <div v-show="error" class="error"> {{ error }} </div>
    <vue-recaptcha
        name='captcha'
        ref='recaptcha'
        size="invisible"
        :class="{'is-error': error }"
        :sitekey="key"
        v-model='captcha'
        @verify='setValue($event)'
        @expired='onExpiredReset'
    ></vue-recaptcha>
  </div>
</template>
<script>
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'ui-captcha',
  components: {
    VueRecaptcha,
  },
  props: {
    // eslint-disable-next-line vue/require-prop-type-constructor
    error: '',
    // eslint-disable-next-line vue/require-prop-type-constructor
    reset: '',
  },
  data() {
    return {
      captcha: '',
      key: window.captcha,
    }
  },
  watch: {
    reset() {
      this.$refs.recaptcha.reset()
    },
  },
  methods: {
    onExpiredReset() {
      this.captcha = ''
    },
    setValue(event) {
      this.captcha = event
      this.$emit('input', this.captcha)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/app/UiElements/UiCaptcha.vue